import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';

export type TrackRecordResolutionTableProps = {
  trackRecordData: string | null;
};

export const TrackRecordResolutionTable: React.FC<TrackRecordResolutionTableProps> = ({ trackRecordData }) => {
  if (!trackRecordData) return null;

  let parsedTrackRecord: any;
  try {
    parsedTrackRecord = JSON.parse(trackRecordData);
  } catch (e) {
    console.error('Invalid JSON in trackRecordData', e);
    return null;
  }

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(value);
  };

  const rows = [
    { label: 'Entity', value: parsedTrackRecord?.entityName ?? '' },
    { label: 'Deal Type', value: parsedTrackRecord?.dealType ?? 'N/A' },
    { label: 'Renovation Budget', value: parsedTrackRecord?.rehabBudget ? formatCurrency(parsedTrackRecord?.rehabBudget) : '-' },
    { label: 'Purchase Date', value: parsedTrackRecord?.purchaseDate },
  ];

  return (
    <Box mt={2} border={1} borderColor="#ccc" borderRadius={4}>
      <Box bgcolor="#f5f5f5" p={2}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          {parsedTrackRecord?.fullAddress?.toUpperCase()} {parsedTrackRecord?.purchaseDate}
        </Typography>
      </Box>

      <Grid container spacing={0} style={{ borderTop: '1px solid #ccc' }}>
        {rows.map((row, index) => (
          <React.Fragment key={index}>
            <Grid item xs={4} style={{ borderTop: '1px solid #eee', borderRight: '1px solid #eee', padding: 8 }}>
              <Typography variant="body2" color="textSecondary">{row.label}</Typography>
            </Grid>
            <Grid item xs={8} style={{ borderTop: '1px solid #eee', padding: 8 }}>
              <Typography variant="body2">{row.value ?? '-'}</Typography>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};
